"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var formik_1 = require("formik");
var react_datepicker_1 = require("react-datepicker");
var EditDebtGoodsAndServices_1 = require("./EditDebtGoodsAndServices");
var OriginalAmountFields_1 = require("../../../AddDebtWizard/addDebt/AddDebtWizardPages/OriginalAmount/OriginalAmountFields");
var InterestRate_1 = require("../../../AddDebtWizard/addDebt/InterestRate/InterestRate");
var EditDebtDebtDetails = function (props) {
    var _a;
    return (React.createElement("div", { className: "flex-column" },
        React.createElement("div", { className: "edit-debt-goods-and-services-label" },
            React.createElement("label", { className: "required", style: { marginBottom: '0.5rem' } }, "Goods/Services")),
        React.createElement(EditDebtGoodsAndServices_1.default, { values: props.values, setFieldValue: props.setFieldValue, setFieldTouched: props.setFieldTouched, disabled: props.disabled }),
        React.createElement("div", { style: { marginBottom: '1.5rem', marginTop: '1rem' } },
            React.createElement("label", { className: "required", style: { marginBottom: '0.5rem' } }, "Amount charged for goods/services"),
            React.createElement(OriginalAmountFields_1.default, { values: props.values, setFieldValue: props.setFieldValue, setFieldTouched: props.setFieldTouched, status: props.status }),
            React.createElement(formik_1.ErrorMessage, { name: "original_amount" }, function (msg) { return React.createElement("div", { className: "error-feedback edit-debt-amount" }, msg); })),
        React.createElement("div", { className: "form-input full-width" },
            React.createElement("label", { htmlFor: "purchase_order_number" }, "Personal Reference"),
            React.createElement("input", { type: "text", name: "purchase_order_number", value: props.values.purchase_order_number, onChange: function (e) {
                    var _a;
                    var value = e.target.value;
                    (_a = props.setFieldTouched) === null || _a === void 0 ? void 0 : _a.call(props, 'purchase_order_number', true, true);
                    props.setFieldValue('purchase_order_number', value);
                }, placeholder: "Reference", disabled: props.disabled })),
        React.createElement(formik_1.ErrorMessage, { name: "purchase_order_number" }, function (msg) { return React.createElement("div", { className: "error-feedback edit-debt" }, msg); }),
        React.createElement("div", { className: "form-input ".concat(props.values.purchase_order_number !== '' && props.values.purchase_order_number !== null
                ? 'full-width'
                : 'hidden_field') },
            React.createElement("label", { htmlFor: "purchase_order_date" }, "Purchase Order Date"),
            React.createElement(formik_1.Field, { render: function (_a) {
                    var field = _a.field;
                    return (React.createElement(react_datepicker_1.default, __assign({}, field, { selected: Date.parse(props.values.purchase_order_date), onChange: function (value) {
                            props.setFieldValue('purchase_order_date', value);
                        }, popperPlacement: "top-end", popperModifiers: {
                            offset: {
                                enabled: true,
                                offset: '5px, 10px',
                            },
                            preventOverflow: {
                                enabled: true,
                                escapeWithReference: false,
                                boundariesElement: 'viewport',
                            },
                        }, dateFormat: "dd/MM/yyyy", placeholderText: "Click to select a date", todayButton: 'Today', maxDate: new Date() })));
                }, name: "purchase_order_date", disabled: props.disabled })),
        React.createElement(formik_1.ErrorMessage, { name: "purchase_order_date" }, function (msg) { return React.createElement("div", { className: "error-feedback" }, msg); }),
        React.createElement("div", { style: { marginLeft: '0', marginRight: '0', marginBottom: '1.25rem' }, className: "form-panel form-panel-coloured" },
            React.createElement("label", { style: { marginBottom: '1rem' } }, "What is the interest rate you are charging? "),
            React.createElement(InterestRate_1.default, { value: props.values.interest_rate, setFieldValue: props.setFieldValue, setFieldTouched: (_a = props.setFieldTouched) !== null && _a !== void 0 ? _a : (function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                    return [2 /*return*/];
                }); }); }), validator: props.validator, protocol: props.values.protocol_id, BOEInterestRate: props.BOEInterestRate }),
            React.createElement(formik_1.ErrorMessage, { name: "interest_rate" }, function (msg) { return React.createElement("div", { className: "error-feedback edit-debt-interest" }, msg); }))));
};
exports.default = EditDebtDebtDetails;
